<template>
    <span class="tw:inline-flex tw:flex-wrap tw:items-baseline tw:justify-center tw:gap-1">
        <span class="tw:font-medium tw:text-slate-700">{{ props.canal.entradas }} ent.</span>
        <span class="tw:text-xs tw:text-slate-400">({{ importe(props.canal.importe) }})</span>
    </span>
</template>

<script setup>
    import appFilters from '@/filters';

    const props = defineProps({
        /** `{ entradas, importe }` de un canal de venta. */
        canal: {
            type: Object,
            required: true
        }
    });

    const importe = appFilters.formatear_precio;
</script>
